import cn from 'clsx'

export default function CreatorTermsOfService() {
	return (
		<div className="max-width-container m-auto w-full">
			<div className="m-auto divide-y">
				<h1 className="py-4 px-4 text-4xl font-bold md:px-0">Sup's Platform by Sup Labs Ltd.</h1>

				<div className="m-auto divide-y py-4 ">
					<div className="px-4 md:px-0">
						<h1 className="text-align-left text-3xl font-bold">Creator Terms of Service</h1>
						<Paragraph>
							These terms of service (“Agreement” or “Terms”) are a legally binding agreement
							between you (“Creator,” “you”), and Sup Labs Ltd., including its affiliates (“Sup,”
							“we,” “us,” or “our”).
						</Paragraph>
						<Paragraph>
							Sup is the owner and operator of a unique technology platform named Sup (the
							“Platform”) and provides products and services (collectively, with the Platform, App,
							and Website, referred to as the “Services”) that enable companies or their agencies,
							who wish to create content and/or advertise their products and services (“Brands”),
							and influencers and others who create Content (“Creators”) to collaborate on the
							Brand’s advertising campaign (“Campaign Brief"). You may create, copy, text, video,
							images, photographs, graphics, messages, or other materials (“Content”) pursuant to
							your participation in the Campaign Brief or advertising for a Brand or its agency (a
							“Campaign”) and post, promote, and advertise the Content through your media network
							(including your website or your posts on any website or social media provider account)
							using the Services.
						</Paragraph>
						<Paragraph>
							PLEASE READ THESE TERMS CAREFULLY TO ENSURE THAT YOU UNDERSTAND EACH PROVISION. THESE
							TERMS CONTAIN A BINDING AGREEMENT AND INCLUDE MANDATORY ARBITRATION AND CLASS
							ACTION/JURY TRIAL WAIVER PROVISION THAT REQUIRES THE USE OF ARBITRATION ON AN
							INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR CLASS ACTIONS, AND
							LIMITS THE REMEDIES AVAILABLE TO YOU IN THE EVENT OF CERTAIN DISPUTES.
						</Paragraph>
						<Paragraph>
							BY ACCEPTING THIS AGREEMENT, EITHER BY CLICKING A BOX INDICATING YOUR ACCEPTANCE, BY
							DOWNLOADING OUR MOBILE APPLICATION, ESTABLISHING AN ACCOUNT, USING THE PLATFORM AND/OR
							OUR SERVICES, YOU AGREE THAT YOU: (A) HAVE READ AND UNDERSTOOD THIS AGREEMENT; (B)
							REPRESENT THAT YOU ARE AT LEAST 18 YEARS OLD OR THAT YOU HAVE PERMISSION FROM YOUR
							PARENT OR LEGAL GUARDIAN TO CREATE AN ACCOUNT AND AGREE TO THIS AGREEMENT; AND (C)
							AGREE THAT YOU ARE LEGALLY BOUND BY THIS AGREEMENT AS WELL AS ANY APPLICABLE
							UNDERLYING CAMPAIGN BRIEFS.
						</Paragraph>
						<Paragraph>
							IF YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY,
							YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND SUCH ENTITY AND ITS AFFILIATES TO
							THESE TERMS, IN WHICH CASE THE TERMS “YOU” OR “YOUR” SHALL REFER TO SUCH ENTITY AND
							ITS AFFILIATES.
						</Paragraph>
					</div>

					<ol className="list-inside list-decimal">
						<Section title="SERVICES AND LICENSE">
							<Paragraph>
								Subject to your compliance with the terms of this Agreement, we grant you access to
								the Platform through our mobile application(s) (the "App") and/or our website for
								Creators that is available at creators.sup.com (the "Website") to use our Services.
								If you access the Services via our App, we grant you a non-exclusive, revocable,
								non-sublicensable, and nontransferable licence during the Term to:
							</Paragraph>
							<Paragraph>
								<ol className="list-inside list-[lower-alpha]">
									<li>
										download, install, and use the App for your use in accordance with these Terms
										on a single mobile device owned or otherwise controlled by you ("Mobile
										Device"), and
									</li>
									<li>
										access, stream, download and use on such Mobile Device content and Services made
										available in or otherwise accessible through the App in accordance with these
										Terms.
									</li>
								</ol>
							</Paragraph>

							<Paragraph>
								Some or all of the Services' functionality may not work with all carriers or mobile
								devices. By accessing the Services on a Mobile Device, you agree that we may
								communicate with you by push notifications, text message, or other electronic means
								to such Mobile Device and that certain information about your usage of the Services
								through the Mobile Device may be communicated to us.
							</Paragraph>
						</Section>

						<Section title="SERVICE RESTRICTIONS">
							<Paragraph>
								You agree that the Services, including, without limitation, graphics, trademarks,
								and editorial content, are owned by Sup Labs Ltd and/or its licensors, and are
								protected by applicable intellectual property and other laws. You agree that you
								will use the Services only as permitted by this Agreement. You agree not to:
							</Paragraph>
							<Paragraph>
								<ol className="list-inside list-[lower-roman]">
									<li>
										reverse engineer, decompile, disassemble or otherwise attempt to discover the
										source code, object code or underlying structure, mine data from The Sup Group
										Ltd's systems, ideas or algorithms, documentation or data related to the
										Services;
									</li>
									<li>modify, translate, or create derivative works based on the Services;</li>
									<li>
										rent, lease, loan, sell, distribute, or create derivative works based on the
										Services, in any manner, or otherwise permit third-parties to use the Platform;
									</li>
									<li>
										exploit the Services in any unauthorized way whatsoever, including but not
										limited to, using the Services to transmit any computer viruses, worms, Trojan
										horses, or other malware, or by trespass or burdening network capacity;
									</li>
									<li>use the Services to provide services to any unauthorized third-parties;</li>
									<li>
										circumvent or disable any security or other technological features or measures
										of the Services;
									</li>
									<li>
										take any action to contest our intellectual property rights or infringe them in
										any way;
									</li>
									<li>use the Services for any illegal or unauthorized purpose;</li>
									<li>remove any proprietary notices or labels; or</li>
									<li>
										reproduce or distribute copyrighted materials of Brands unless you are duly
										authorized by such Brands to do so.
									</li>
								</ol>
							</Paragraph>
							<Paragraph>
								You further agree not to use the Services in any manner to harass, abuse, stalk,
								threaten, defame, or otherwise infringe or violate the rights of any other party,
								and that Sup Labs Ltd is not in any way responsible for any such use by you, nor for
								any harassing, threatening, defamatory, offensive, infringing, or illegal messages
								that you may receive as a result of using the Services.
							</Paragraph>
						</Section>

						<Section title="RESERVATION OF RIGHTS">
							<Paragraph>
								You acknowledge and agree that the Services are provided under license, and not
								sold, to you. Except to the extent necessary to access and use the Services, nothing
								in this Agreement grants any title or ownership interest in or to any copyrights,
								patents, trademarks, trade secrets, or other proprietary rights in or relating to
								the Services whether expressly, by implication, estoppel, or otherwise. The Sup
								Group Ltd and its licensors and service providers reserve and shall retain their
								entire right, title, and interest in and to the Services, including all copyrights,
								trademarks, and other intellectual property rights therein or relating thereto,
								except as expressly granted to you in this Agreement.
							</Paragraph>
						</Section>

						<Section title="COMPLIANCE WITH LAWS AND POLICIES">
							<Paragraph>
								You agree that you and all of your Content will fully comply with applicable laws,
								rules, regulations, and industry guidelines, including but not limited to the United
								Kingdom legal equivalents of Applicable Laws, such as the Advertising Standards
								Authority (ASA) rules, and that you will disclose in every post that mentions or
								features a Brand that you have received benefits from the Brand as described in this
								Agreement and the Campaign Brief. You will cooperate with us in removing or
								modifying any inappropriate Content relating to the Brand, its products, or the
								Campaign Brief from your blog, website, or your accounts on social networking
								websites, such as Instagram, Facebook, Pinterest, TikTok, or Snapchat ("Social Media
								Provider") or any other media over which you have control. To the extent you are not
								in compliance with the terms required under this Agreement (without limiting any
								remedies that may be available to us and a Brand in law or equity), you will
								promptly remove and take down any non-compliant Content from the Platform and from
								any Social Media Provider.
							</Paragraph>
						</Section>

						<Section title="REPRESENTATIONS AND WARRANTIES">
							<Paragraph>
								You represent and warrant that: (a) you have the full power and authority to enter
								into this Agreement and any Campaign, and neither this Agreement nor your activity
								hereunder conflicts with any obligation on your part; (b) all information submitted
								by you and all statements made by you will comply with all Applicable Laws in the
								United Kingdom and are accurate; (c) to the extent that you upload any Content
								through the use of the Services, you represent that you own all rights in, or have
								authorization or are otherwise legally permitted to upload, such Content and that
								such Content does not infringe on any third party intellectual property or other
								rights, including, without limitation, patent, copyright, trademark, or trade
								secrets, in such Content, violate any terms of service applicable to any Social
								Media Provider, or this Agreement; (d) you are legally permissible to work on any
								Campaign that you apply to participate in, including compliance with any relevant UK
								labor laws for Creators who are under 18 years of age; (e) you are not under 13
								years of age; (f) you will not disparage, defame, or otherwise diminish the goodwill
								or reputation of Sup Labs Ltd, the Brands, and/or the Agencies; and (g) you will not
								participate in a Campaign or work for a competitor of a Brand while you are
								participating in a Campaign of the Brand, unless otherwise agreed in writing with
								such Brand. You agree to defend, indemnify, and hold us and our officers, directors,
								employees, agents, and contractors (collectively "Indemnitees") harmless from any
								damages, liabilities, litigation, judgments, settlements, penalties, fines,
								expenses, including attorneys' and experts' fees, and other comparable costs
								(collectively "Damages") that arise from or relate to a breach of the
								representations and warranties set forth in this Section 5 of these Terms.
							</Paragraph>
						</Section>

						<Section title="CONTENT LICENCE">
							<Paragraph>
								You grant to Sup Labs Ltd and its affiliated entities a perpetual, royalty-free,
								fully paid-up, irrevocable, and non-exclusive license to copy, display, modify,
								distribute, store, and otherwise use the Content you submit to the Platform for the
								purposes of: (a) conducting our, and our affiliated entities, marketing activities
								in the promotion of the Services including but not limited to email marketing, case
								studies, cover photos, and use on our social networking websites, websites, and
								mobile applications; and (b) performing our obligations under this Agreement,
								including provisioning your participation using the Services under a Campaign Brief.
								Subject to the terms of the applicable Campaign Brief, you grant the Brand or its
								agency an exclusive (except to the rights granted herein), worldwide, royalty-free,
								fully paid-up, transferable, sublicensable, perpetual, irrevocable license to copy,
								display, upload, distribute, store, modify, and otherwise use any Content that you
								upload, transfer, or post using the Services or otherwise use in connection with a
								Campaign.
							</Paragraph>
						</Section>

						<Section title="ACCOUNTS AND SOCIAL MEDIA PROVIDERS">
							<Paragraph>
								To use the Services, you need to establish an account by signing up through our App
								or our Website (the "Account"). You agree to provide accurate, current, and complete
								information about yourself. Registration data and other information about you and
								this Agreement are used, stored, and disclosed in accordance with our Privacy
								Policy. You acknowledge and agree:
							</Paragraph>
							<Paragraph>
								<ol className="list-inside list-[lower-roman]">
									<li>
										to provide accurate and complete Account and login information (where
										applicable) (e.g., full name and email);
									</li>
									<li>to keep all Account login details and passwords secure at all times;</li>
									<li>
										to remain solely responsible and liable for the activity that occurs in
										connection with your Account; and
									</li>
									<li>
										to promptly notify us in writing if you become aware of any unauthorized access
										or use of your Account or the Platform.
									</li>
								</ol>
							</Paragraph>
							<Paragraph>
								You represent and warrant that if you are entering into these Terms on behalf of
								your employer or other legal entity, you have full authority to bind said employer
								or other legal entity to this Agreement. Once you create an Account, you will be
								able to customize your profile ("Creator Profile"). You are liable for any Damages
								caused by any unauthorized use of your password, username, or Account. If you are
								under 13 years of age, do not create an account, download our App, or access our
								Services in any manner. Sup Labs Ltd's Services are not intended for anyone under 13
								years of age. If you believe someone under 13 years of age may have created an
								Account on our Platform, please let us know by contacting us at info@sup.co. If you
								are between 13 years of age and 18 years of age, then you may create an Account only
								if: (a) you have permission from your parent or legal guardian to create an Account
								and to agree to these Terms, and upon request, you are able to provide proof of such
								permission, and (b) you are legally permissible to apply for and complete Campaigns
								under the applicable UK laws and regulations, including compliance with Fair Labor
								Standards Act (FLSA) or other youth or child labor laws if applicable.
							</Paragraph>
							<Paragraph>
								If you are found to be in breach of this Section, Sup Labs Ltd reserves the right to
								terminate your Account immediately and bar you from establishing any other Account
								without giving any notice to you.
							</Paragraph>
							<Paragraph>
								DO NOT SIGN UP FOR AN ACCOUNT IF YOU DO NOT AGREE TO BE BOUND BY AND COMPLY WITH
								THIS AGREEMENT. BY OPENING UP AN ACCOUNT, YOU AGREE TO BE BOUND BY AND COMPLY FULLY
								WITH THIS AGREEMENT.
							</Paragraph>
							<Paragraph>
								In order to fully use the Services, you will need to verify your Social Media
								Provider account(s). Once your Social Media Provider is verified by us, we may
								access information and relevant data provided by you and your Social Media Provider,
								and we will use, store, and disclose such information in accordance with our Privacy
								Policy. You may need to provide your login information, including your password,
								directly to such Social Media Provider, and not to us. We are not responsible for
								any action taken by the Social Media Providers or the accuracy or availability of
								any information provided by the Social Media Providers. You agree to defend,
								indemnify, and hold Sup Labs Ltd and its Indemnitees harmless from any and all
								Damages that result from your breach of this Section 7.
							</Paragraph>
						</Section>

						<Section title="SUP COMMUNICATION">
							<Paragraph>
								By establishing an Account with Sup Labs Ltd on the Platform, you agree to receive
								communications from us, including via email, text messages, and push notifications.
								If you wish to not receive any promotional emails from The Sup Group Ltd, please
								email help@sup.co or follow the unsubscribe options in the promotional emails. You
								may not be able to unsubscribe from receiving essential Service-related and
								Account-related informational (transactional) emails from Sup Labs Ltd. If you do
								wish to unsubscribe from such emails, please send your request to help@sup.co with
								the subject line: "Unsubscribe from Sup Labs Ltd Transactional Emails." Please note
								that unsubscribing from such emails will impact your use and enjoyment of Sup Labs
								Ltd Services, including the Platform, Website, and App, and will impact your
								communication with us and/or Brands. You can opt out of receiving push notifications
								through your device settings. Please note that opting out of receiving push
								notifications may impact your use of our Services.
							</Paragraph>
						</Section>

						<Section title="ACCEPTABLE USE POLICY AND CORRECTIVE ACTION">
							<Paragraph>
								You are responsible for your conduct and any Content that you upload, share, post,
								submit, publish, send, display, or transmit (collectively, "Transmit") via the
								Services. You agree that you will never use the Services to:
							</Paragraph>
							<Paragraph>
								<ul className="list-inside list-disc">
									<li>
										Transmit Content in any manner that infringes any intellectual property or other
										proprietary rights of any party;
									</li>
									<li>
										Transmit Content that is unlawful or promotes unlawful activity or provides
										instructional information about unlawful activities, or that is harmful,
										threatening, abusive, harassing, inflammatory, tortious, excessively violent,
										defamatory, vulgar, obscene, pornographic, sexually suggestive, libelous,
										invasive of another's privacy (or creates a privacy or security risk to any
										person), or hateful racially or ethnically;
									</li>
									<li>
										Transmit Content that constitutes unsolicited or unauthorized advertising or
										promotional materials or commercial activities;
									</li>
									<li>
										Impersonate any person or entity, or falsely state or otherwise misrepresent or
										fail to represent your affiliation with a person or entity; or
									</li>
									<li>
										Transmit any software viruses, spyware, worms, malware, or any other computer
										code, files, or programs designed to interrupt, destroy, or limit the
										functionality of any computer software or hardware or other equipment.
									</li>
								</ul>
							</Paragraph>
						</Section>

						<Section title="APPLYING TO PARTICIPATE IN A CAMPAIGN AND/OR USING OUR THREADS">
							<Paragraph>
								You may be able to view different Brands' Campaigns based on your followers on
								Social Media Provider and any other parameters decided by the Brands. Brands may
								require you to provide certain information related to your age, gender, or location
								in order to participate in a Campaign. See our Privacy Policy for more information.
								You may decline to provide this information. But if you do, you may not be able to
								participate in a Campaign.
							</Paragraph>
							<Paragraph>
								The Campaigns that you can see and apply to are solely based on social networks that
								you have connected to the Platform and your follower counts on such social networks
								and not on your age, gender, or location or any other information you provide to us,
								unless otherwise communicated to you via the Platform or other communications, such
								as email or based on parameters as further described in a Campaign Brief. However,
								you may be a recommended match for a Campaign based on information you provide and
								the information provided by the Brand or its agency. These recommendations in no
								manner guarantee that the Brand or its agency will select you to participate in the
								Campaign. You may participate in multiple Campaigns with different Brands or
								agencies, provided such Brand or its agency approves your participation in such
								Campaigns.
							</Paragraph>
							<Paragraph>
								By using the Services, including but not limited to when you apply to a Campaign
								Brief or engage with us or a Brand via our Threads tool, you authorize us to provide
								the Brand or its agency with some or all of the following information concerning
								you:
							</Paragraph>
							<Paragraph>
								<ul className="list-inside list-disc">
									<li>Your name and Social Media Provider identification and handle;</li>
									<li>Your contact information and email address;</li>
									<li>Rates and pricing to which you have agreed;</li>
									<li>Sizing, product preferences, and biographical information;</li>
									<li>Information from your Creator Profile;</li>
									<li>
										Any ideas, content, or answers you provide to questions listed as part of the
										application process for each campaign; and
									</li>
									<li>
										Any additional information or Content you decide to share via our Threads tool.
									</li>
								</ul>
							</Paragraph>

							<Paragraph>
								A Campaign Brief includes the terms, conditions, fees, parameters, specifications,
								and other terms and conditions of a Brand's campaign. The Campaign Brief is a legal
								contract between you and Sup Labs Ltd and/or the agency on behalf of The Sup Group
								Ltd. You agree to treat the contents of the Campaign Brief and any information
								related to Sup Labs Ltd and its agency as confidential and not to disclose such
								information to any third party. It is hereby clarified that the Brief shall prevail
								with respect to any specific terms not detailed in these Terms or in the event of
								any contradiction between these Terms and the Brief.
							</Paragraph>
							<Paragraph>
								The Brands and/or the agencies are a third party beneficiary of this Agreement and,
								upon your acceptance of this Agreement and participation in a Campaign, The Sup
								Group Ltd and/or its agency shall have the right (and will be deemed to have
								accepted the right) to enforce this Agreement against you as a third party
								beneficiary hereof. This Agreement incorporates by reference Sup Labs Ltd's and/or
								its agency's Brief, which is an enforceable agreement between you and The Sup Group
								Ltd and/or its agency. Your access to and use of the materials in the Campaign Brief
								requires you to review, acknowledge, and accept the terms of the Campaign Brief, and
								once executed by you, will constitute a valid and binding agreement, and such terms
								and conditions will be incorporated into this Agreement for all purposes.
							</Paragraph>
							<Paragraph>
								Your failure to agree to the Campaign Brief will restrict you from participating in
								the Campaign. Any noncompliance by you with the terms of such Campaign Brief will be
								deemed a violation of this Agreement. In order to assign you a Campaign or approve
								your participation in a Campaign, Brands may be able to view your avatar, ratings,
								and content posted on your Social Media Provider. They will also be able to look at
								your stats related to completion of your Campaigns, etc. If necessary, Brands will
								contact you through the Service.
							</Paragraph>
							<Paragraph>
								If your participation in a Campaign is approved and accepted by Sup Labs Ltd and/or
								its agency on behalf of Sup Labs Ltd, you agree to Transmit the Content to your
								Social Media Provider as directed in the Campaign Brief. Unless otherwise agreed
								upon in writing with a Brand, you agree that the Content that you produce for a
								Campaign will be fully owned by Sup Labs Ltd to the fullest extent allowed by
								Applicable Laws and that you will not have the right to use such Content after the
								Campaign without the prior written consent of Sup Labs Ltd and/or its agency on
								behalf of Sup Labs Ltd.
							</Paragraph>
							<Paragraph>
								You acknowledge, agree, represent, and warrant that (i) Sup Labs Ltd will not in any
								manner approve or be responsible for your Content whether or not posted on the
								Platform or you use our Services in connection with a Campaign, and (ii) you are
								solely responsible for your Content whether or not posted on the Platform or you use
								our Services in connection with a Campaign. You agree to defend, indemnify, and hold
								Sup Labs Ltd harmless from any Damages arising out of or in connection with your
								breach of this representation and warranty.
							</Paragraph>
							<Paragraph>
								You agree not to use any Content in a Campaign which is not approved in advance by
								Sup Labs Ltd and/or its agency. You agree to comply with all of the terms and
								conditions of the Campaign Brief. By posting Content on any social media, you agree
								to comply with and be bound by the terms and conditions of the Campaign Brief. Do
								not post Content if you do not agree to all of the terms and conditions of the
								Campaign Brief.
							</Paragraph>
						</Section>

						<Section title="BRAND FEEDBACK">
							After your Content is approved by the Brand or its agency, Sup Labs Ltd or its agency
							may be able to give you a review based on the criteria that are listed on the Campaign
							Brief.
						</Section>

						<Section title="YOUR CODE OF CONDUCT AND OBLIGATIONS UNDER A CAMPAIGN BRIEF">
							<Paragraph>
								In connection with your participation in a Campaign, you agree at all times to
								comply with the following code of conduct:
							</Paragraph>
							<Paragraph>
								<ul className="list-inside list-disc">
									<li>
										You will abide by all terms and conditions outlined in the applicable Campaign
										Brief, including but not limited to required social media tags and disclosures
										("Required Tags").
									</li>
									<li>
										You will comply with all of the terms and conditions of the Campaign Brief.
									</li>
									<li>
										You agree that you shall disclose your connection to the Brand in each post of
										Content as specified by the Campaign Brief by including, for instance, a hashtag
										such as #ad or #sponsored or a phrase similar to, "I'm working for [Brand
										Name]".
									</li>
									<li>
										You agree to follow all required photo review and approval processes required by
										the Brand.
									</li>
									<li>
										You agree that you will not transmit any Content to your website or Social Media
										Provider account without obtaining the prior written approval of the Brand or
										its agency.
									</li>
									<li>
										You further agree that the Brand or its agency has the sole discretion to accept
										or reject your submitted Content.
									</li>
									<li>
										You agree to comply with all the applicable laws, rules, regulations, and
										guidelines.
									</li>
									<li>
										You will clearly and conspicuously identify your connection with the Brand
										(i.e., that you received benefits) at any time you make a public statement or
										post about the Brand or its products or services.
									</li>
									<li>
										You will state your honest views regarding the products, which must reflect your
										true and actual experiences, opinions, and beliefs based upon your use of the
										Brand's products or services. You agree not to make claims about the Brand or
										its products or services that are not within the reasonable written guidelines
										provided to you by the Brand or its agency.
									</li>
									<li>
										You will limit your posting of Content to those websites and Social Media
										Provider accounts specified in the Campaign Brief.
									</li>
									<li>
										You will represent the Brand and its products and services in a positive light.
									</li>
									<li>
										You will not make any statements regarding the products or services of the
										Brand's competitors.
									</li>
									<li>
										You will not impersonate any other person or entity, actual or fictitious,
										including by impersonating an employee or consultant of the Brand.
									</li>
									<li>
										You will respect the intellectual property and proprietary rights of others, and
										you will not post any Content unless you have the necessary permissions,
										including any identifiable third-party brand logos or markers, and you will not
										post the confidential or proprietary information of any party.
									</li>
									<li>
										You agree that if any Content contains an image of another identifiable person,
										you have obtained from them all necessary authorizations and will obtain a
										written release in a form acceptable to us as requested.
									</li>
									<li>
										You will ensure that the Content will not include Content that is profane,
										pornographic, sexually explicit, violent, or derogatory of any ethnicity, race,
										gender, religion or faith, profession, or age group; promotes excessive alcohol
										consumption or illegal drugs, tobacco, firearms/weapons, or a particular
										political agenda; is obscene or offensive; or promotes or depicts unsafe
										activities or inhumane behavior or activities.
									</li>
									<li>
										You further ensure that the Content will not be placed adjacent to content that
										promotes pornography, violence, or the use of firearms, contains obscene
										language, or falls within another category stated in the Campaign Brief.
									</li>
									<li>
										You will comply with all industry-specific rules and regulations as instructed
										in the Campaign Brief relating to the advertising of the Brand's products or
										services.
									</li>
									<li>
										You agree not to edit Content after Transmit unless otherwise noted in the
										Campaign Brief or notified in writing by the Brand or Sup Labs Ltd.
									</li>
									<li>
										We reserve the right, on behalf of the Brands and/or their agencies, for any
										reason or no reason, to remove from the Platform or Services any Content posted
										by you. To the extent you are not in compliance with the terms of the Campaign
										Brief (without limiting any remedies that may be available to us) or you violate
										any of these code of conduct requirements, you will, promptly upon receiving a
										written request from us, the Brand or its agency, correct, replace, remove,
										and/or take down any non-compliant Content that you have posted to your Social
										Media Provider accounts or any website to which you have posted Content.
									</li>
								</ul>
							</Paragraph>
						</Section>

						<Section title="PAYMENT">
							<Paragraph>
								Subject to your compliance with this Agreement and the Campaign Brief, you shall be
								compensated in United Kingdom pounds ("Payment") for the Content that is accepted by
								the Brand and posted to your Social Media Provider accounts or web pages in
								accordance with the terms of the Campaign Brief. To the extent that you are entitled
								to Payment, we will determine the method, and you will provide reasonable
								cooperation in facilitating the Payment. Subject to your cooperation in facilitating
								the Payment and subject to the Content being accepted by the Brand, the Payment will
								be made within thirty (30) days following the completion of all deliverables
								associated with the Campaign.
							</Paragraph>

							<Paragraph>
								For example, if we pay you through PayPal, you will be required to establish a
								PayPal account and provide us with sufficient information to allow us to transfer
								funds to you. If we pay you via ACH through Dwolla, another third-party payment
								provider, you will provide Dwolla with accurate payment information through our
								Platform, and you expressly authorize Sup Labs Ltd's service provider, Dwolla, Inc.,
								to originate credit transfers to your financial institution. Unless otherwise agreed
								to by you and the Brand or its agency on behalf of the Brand, your fees and other
								consideration for your participation in the Campaign will be set forth in the
								Campaign Brief.
							</Paragraph>

							<Paragraph>You agree:</Paragraph>
							<Paragraph>
								<ul className="list-inside list-disc">
									<li>
										To provide accurate information for facilitating Payment. You may be required to
										enter the information for our above-mentioned third-party payment providers over
										our Platform. Please note that Sup Labs Ltd does not store or display the
										information, except displaying the last four (4) digits of your bank account
										when you enter the information. If we are unable to facilitate the Payment
										because of inaccurate information provided by you, we will inform you through
										reasonable means, and you will have 15 days to furnish accurate information to
										us for facilitating Payment.
									</li>
									<li>
										That Sup Labs Ltd is not responsible for any Payment made to an incorrect bank
										account or PayPal account based on incorrect information provided by you.
									</li>
									<li>
										To promptly return the Payment to us if at any time it is determined that you
										were paid by us in error or have been paid for a Campaign where you did not
										fully fulfill the obligations as outlined in the Campaign Brief or in accordance
										with the Campaign Brief. Sup Labs Ltd will contact you if this is the case, and
										we will provide you with information for returning the funds to us. The Payment
										must be returned by you to us within 7 days of receiving return payment
										information. Alternatively, we may deduct the amount to be returned by you from
										future payments.
									</li>
									<li>
										To promptly return any payments to us if such payments remitted to you are more
										than the Payment due. You also agree to contact us immediately at contact@sup.co
										to inform any overpayment.
									</li>
									<li>
										You, the Creator, are responsible for all fees, such as equipment rentals,
										photographer fees, model fees, location fees, government fees, etc., that may be
										incurred in connection with a Campaign.
									</li>
									<li>
										You will report to all applicable government agencies as income all payments
										received by you pursuant to this Agreement. This means you will be solely
										responsible for payment of all withholding taxes, social security, workers'
										compensation, unemployment and disability insurance, or similar items required
										by any government agency for any payments received by you.
									</li>
									<li>
										You are not entitled to any benefits paid or made available by Sup Labs Ltd to
										its employees, including, without limitation, any vacation or illness payments,
										or to participate in any plans, arrangements, or distributions made by Sup Labs
										Ltd pertaining to any bonus, stock option, profit-sharing, insurance, or similar
										benefits.
									</li>
									<li>
										To defend, indemnify, and hold harmless Sup Labs Ltd and its Indemnitees from
										and against any and all Damages arising from your breach of the foregoing
										obligations.
									</li>
								</ul>
							</Paragraph>
						</Section>

						<Section title="CONFIDENTIALITY">
							<Paragraph>
								In the event that any information is disclosed to you through your access to the
								Services related in any way to Sup Labs Ltd and its business and the business of its
								customers, which it deems to be confidential and proprietary, including but not
								limited to any Campaign Brief, you agree to hold such information in the strictest
								confidence. You acknowledge that we or a Brand or its agency may provide
								confidential and proprietary information to you in connection with your use of the
								Services or participation in a Campaign, including but not limited to The Sup Group
								Ltd's Platform, App, identity of our customers, including any Brand or its agency
								contacts, names, phone numbers, addresses, email addresses, campaign, Campaign
								Brief, campaign history, campaign preferences, pricing information, and other
								information regarding a Brand's products, services, initiatives, or other topics of
								the Campaign Brief, and all other information which Sup Labs Ltd considers to be
								confidential and proprietary or any special treatment that you may receive (which
								Sup Labs Ltd reserves the right to provide in its sole discretion to any creator).
							</Paragraph>

							<Paragraph>
								Except as needed to perform your obligations hereunder, during the Term, you shall
								keep confidential and not disclose any information contained in a Campaign Brief or
								prepared for while participating in a Campaign, including but not limited to topics,
								story projects, or source information, prior to such information becoming available
								to the public. During the Term of this Agreement, you will also keep confidential
								and not disclose the terms of this Agreement or use any such information for your
								own purposes. Any information provided by you and marked as "confidential" shall be
								deemed confidential information.
							</Paragraph>

							<Paragraph>
								Each party agrees that it will take all appropriate steps to protect confidential
								information from unauthorized disclosure, that it will not disclose such
								confidential information to any third party, and that it will not use any
								Confidential Information (other than as authorized by this Agreement) without the
								prior written consent of the other Party. Notwithstanding the above, each party may
								disclose the other party's confidential information to its employees, consultants,
								and representatives on a need-to-know basis, provided that it shall remain liable
								for any breach of the confidentiality obligations under this Agreement by any of the
								aforementioned persons.
							</Paragraph>

							<Paragraph>
								The parties' obligations with respect to confidential information shall continue for
								a period of 5 years from the date of termination or expiration of this Agreement or
								until such confidential information becomes publicly known, other than by breach of
								this Agreement by such Party.
							</Paragraph>
						</Section>

						<Section title="INDEMNIFICATION">
							<Paragraph>
								If Sup Labs Ltd and/or its affiliates, officers, employees, managers, directors,
								customers, and agents (the "Indemnified Parties") incur or suffer any loss or
								liability whatsoever (including but not limited to a fine, penalty, damages award,
								legal costs and expenses such as attorney's fees, etc.) under or in connection with
								any demand, claim, suit, or proceeding made or brought by a third party (whether by
								an individual, organization, or governmental agency) against The Sup Group Ltd
								Indemnified Parties, which could arise from the following:
							</Paragraph>
							<Paragraph>
								Parties, which could arise from the following:
								<Paragraph>
									<ol className="list-inside list-[lower-alpha]">
										<li>
											A breach of this Agreement or underlying Campaign Brief and/or from any use of
											the Services;
										</li>
										<li>
											Any other party's access and use of the Service with your unique username,
											password, or other appropriate security code;
										</li>
										<li>
											The negligence, gross negligence, or willful misconduct of you or your
											employees, agents, or contractors;
										</li>
										<li>Incorrect information provided by you in your Account or elsewhere; or</li>
										<li>
											A failure by you or your employees, agents, contractors, or invitees to comply
											with Applicable Laws and regulations,
										</li>
									</ol>
								</Paragraph>
								<Paragraph>
									each a "Claim," you shall:
									<ul className="list-inside list-[lower-alpha]">
										<li>
											Indemnify and hold harmless the Indemnified Parties for such losses and
											liabilities; and
										</li>
										<li>
											Defend the Indemnified Parties against the Claim at your own cost and expense.
										</li>
									</ul>
								</Paragraph>
								<Paragraph>
									Indemnity Procedure. As a condition to indemnification under this section
									(INDEMNIFICATION), the Indemnified Party agrees:
									<ul className="list-inside list-[upper-alpha]">
										<li>To provide you with prompt written notice of the Claim;</li>
										<li>
											To cede to you sole control of the defense and settlement of the Claim (except
											that any settlement shall require the indemnified Party's prior written
											consent, not to be unreasonably withheld, conditioned, or delayed);
										</li>
										<li>
											To provide you with all information and assistance reasonably requested; and
										</li>
										<li>
											Not to admit any liability under (or otherwise compromise the defense of) the
											Claim. The indemnified Party may participate in the defense of the Claim at
											its own cost and expense.
										</li>
									</ul>
								</Paragraph>
							</Paragraph>
						</Section>

						<Section title="DISCLAIMER OF WARRANTIES">
							<Paragraph>
								Your use of the Services is at your sole risk. The Services are provided on an "as
								is" and "as available" basis. We expressly disclaim, to the fullest extent
								permissible by UK law, all warranties of any kind, whether express, implied, or
								statutory, including, but not limited to, the implied warranties of merchantability,
								fitness for a particular purpose, title, and non-infringement. We make no warranty
								that:
							</Paragraph>

							<Paragraph>
								You agree that Sup Labs Ltd is not liable for any damages or injury resulting from
								your use of our Services or participation in a Campaign. There is no warranty that
								will extend beyond the description on the face hereof. Any damage alleged for a loss
								or injury is limited to the fee, if any, paid to Sup Labs Ltd for the ability to
								access the Platform and/or use of the Services.
							</Paragraph>
						</Section>

						<Section title="LIMITATION OF LIABILITY AND ASSUMPTION OF RISK">
							<Paragraph>
								To the maximum extent permitted by UK law, Sup Labs Ltd shall not be liable for any
								indirect, incidental, special, consequential, or exemplary damages, or damages for
								loss of profits, including fees not received as a result of a malfunction of the
								Platform, whether directly or indirectly, or any loss of data, use, goodwill, or
								other intangible losses based on contract, tort, strict liability, or otherwise. In
								no event shall Sup Labs Ltd's total liability for all claims related to the Services
								or this Agreement exceed the greater of one hundred pounds (£100.00) or any amounts
								paid by Sup Labs Ltd to you in the six (6) months prior to the event giving rise to
								the claim.
							</Paragraph>
							<Paragraph>
								You and your heirs hereby voluntarily agree to release, waive, discharge, and hold
								harmless Sup Labs Ltd and its officers, directors, employees, consultants, agents,
								successors, and assigns from and against any claims, disputes, demands, liabilities,
								damages, losses, and costs and expenses, including, without limitation, reasonable
								legal and accounting fees, arising out of or in any way connected with your access
								to or use of the Services.
							</Paragraph>
						</Section>

						<Section title="TERM AND TERMINATION">
							<Paragraph>
								This Agreement is effective upon your creation of an Account. This Agreement may be
								terminated:
								<Paragraph>
									<ul className="list-inside list-[lower-alpha]">
										<li>
											By you, without cause, upon seven (7) days' prior written notice to The Sup
											Group Ltd, or
										</li>
										<li>
											By either Party immediately, without notice, upon the other Party's material
											breach of this Agreement, including but not limited to any breach of Section
											13 of this Agreement.
										</li>
									</ul>
								</Paragraph>
								<Paragraph>
									In addition, Sup Labs Ltd may, immediately and without notice, terminate this
									Agreement, deactivate your Account, or your Campaign (as applicable) in the event:
									<ul className="list-inside list-decimal">
										<li>You no longer qualify to participate in a Campaign,</li>
										<li>You fall below Sup Labs Ltd or a Brand's rating,</li>
										<li>
											Sup Labs Ltd has the good faith belief that such action is necessary to
											protect the Brand, other Creators, or Sup Labs Ltd's Platform and/or Services,
											or
										</li>
										<li>At the request of the Brand.</li>
									</ul>
								</Paragraph>
								<Paragraph>
									In the event of a deactivation pursuant to (1)-(4) above, you may, at The Sup
									Group Ltd's sole discretion, be given notice of the potential or actual
									deactivation and an opportunity to attempt to cure the issue to The Sup Group
									Ltd's or the Brand's (as applicable) reasonable satisfaction prior to The Sup
									Group Ltd permanently terminating the Agreement. For all other breaches of this
									Agreement, you will be provided notice and an opportunity to cure the breach (to
									the extent curable). If the breach is cured in a timely manner and to The Sup
									Group Ltd's satisfaction, this Agreement will not be permanently terminated.
								</Paragraph>
								<Paragraph>
									Sections 2, 3, 4, 6, 7, 8, 9, 11 to 31 shall survive any termination or expiration
									of this Agreement.
								</Paragraph>
							</Paragraph>
						</Section>

						<Section title="RELATIONSHIP OF THE PARTIES">
							<Paragraph>
								The parties hereto are independent contractors, and nothing contained herein shall
								be interpreted as creating any relationship other than that of independent
								contracting parties. The parties shall not be construed as being partners, joint
								ventures, shareholders, employer/employee, agent/servant. The Creator has no power
								or authority to bind Sup Labs Ltd to any obligation, agreement, debt, or liability.
								The Creator shall not hold itself out as an agent or representative of Sup Labs Ltd.
							</Paragraph>
							<Paragraph>
								Each Creator acknowledges and agrees that:
								<ol className="list-inside list-[lower-alpha]">
									<li>
										He/she is free from the control and direction of Sup Labs Ltd in connection with
										his/her development of Content, participation in a Campaign, or performance of
										his/her obligations and duties under these Terms and the Brief,
									</li>
									<li>
										The services to be performed by such Creator under this Agreement and the Brief
										are outside the usual course of Sup Labs Ltd's business, and
									</li>
									<li>
										Such Creator is customarily engaged in an independently established trade,
										occupation, or business of the same nature as the services to be performed
										pursuant hereto or the Campaign Brief.
									</li>
								</ol>
							</Paragraph>
							<Paragraph>
								The Creator will be solely responsible for determining the method, details, and
								means of performing the services hereunder and in the Campaign Brief and the
								Campaign. Neither party shall be the authorized agent of the other party or have the
								right or authority, either express or implied, to create or incur any liability
								against or on behalf of any other party other than those obligations and liabilities
								in this Agreement.
							</Paragraph>
						</Section>

						<Section title="SUBMISSIONS">
							<Paragraph>
								You acknowledge and agree that any questions, comments, suggestions, ideas,
								feedback, or other information about the Services ("Submissions"), and all rights,
								including intellectual property rights in such Submissions, shall belong exclusively
								to us, Sup Labs Ltd, and that such Submissions shall be considered our confidential
								information. You hereby irrevocably and unconditionally transfer and assign to Sup
								Labs Ltd all intellectual property rights you have or may have in such Submissions
								and waive any and all moral rights that you may have in respect thereof. It is
								further understood that the use of Submissions, if any, may be made by Sup Labs Ltd
								at its sole discretion, and that Sup Labs Ltd in no way shall be obliged to make use
								of any kind of the Submissions or part thereof.
							</Paragraph>
						</Section>

						<Section title="COPYRIGHT INFRINGEMENT/NOTICE">
							<Paragraph>
								21.1. Removal of Content. Pursuant to the Copyright, Designs and Patents Act 1988,
								we have designated a Copyright Agent (as specified below) to receive notifications
								of claimed copyright infringement in connection with the Services. Please be advised
								that we enforce a policy that provides for the termination in appropriate
								circumstances of users of the Services who are repeat infringers.
							</Paragraph>

							<Paragraph>
								If you believe that your work has been copied in a way that constitutes copyright
								infringement, please provide the Copyright Agent with the following information in
								accordance with the Copyright, Designs and Patents Act 1988:
								<ul className="list-inside list-disc">
									<li>
										An electronic or physical signature of the person authorized to act on behalf of
										the owner of the copyright;
									</li>
									<li>A description of the copyrighted work you claim has been infringed;</li>
									<li>
										A description of where the material that you claim is infringing is located on
										the Services, with enough detail that we may find it. Providing URLs in the body
										of an email is the best way to help us locate content quickly;
									</li>
									<li>Your address, telephone number, and email address;</li>
									<li>
										A statement by you that you have a good faith belief that the disputed use is
										not authorized by the copyright owner, its agent, or the law; and
									</li>
									<li>
										A statement by you, made under penalty of perjury, that the above information in
										your notice is accurate and that you are the copyright owner or authorized to
										act on the copyright owner’s behalf.
									</li>
								</ul>
							</Paragraph>
							<Paragraph>
								In the event that you submit an incomplete or deficient Notice or Counter Notice to
								Sup Labs Ltd, Sup Labs Ltd is not obligated to respond or to take further action on
								the matter.
							</Paragraph>
							<Paragraph>
								21.2. Counter-Notification.If you believe that the material you posted was removed
								from the Services by mistake, and that you have the right to post the material, you
								may elect to send us a counternotification. To be effective, the
								counter-notification must be a written communication provided to our Copyright Agent
								that includes substantially the following (please consult your legal counsel or see
								the Copyright, Designs and Patents Act 1988 to confirm these requirements):
							</Paragraph>
							<Paragraph>
								<ul className="list-inside list-disc">
									<li>Your physical or electronic signature;</li>
									<li>
										Identification of the material that has been removed or to which access has been
										disabled and the location at which the material appeared before it was removed
										or access to it was disabled. Providing URLs in the body of an email is the best
										way to help us locate content quickly;
									</li>
									<li>
										A statement under penalty of perjury that you have a good faith belief that the
										material was removed or disabled as a result of mistake or misidentification of
										the material to be removed or disabled; and
									</li>
									<li>
										Your name, address, and telephone number, and a statement that you consent to
										the jurisdiction of the courts of England and Wales, or if your address is
										outside of England and Wales, for any jurisdiction in which the Services may be
										found or accessed, and that you will accept service of process from the person
										who provided notification of infringement or an agent of such person.
									</li>
								</ul>
							</Paragraph>
							<Paragraph>
								21.3. Misrepresentations.Please note that under the Copyright, Designs and Patents
								Act 1988, any person who knowingly materially misrepresents that material or
								activity is infringing or was removed or disabled by mistake or misidentification
								may be subject to liability.
							</Paragraph>

							<Paragraph>
								21.4. Copyright Agent.Our agent for notice of claims of copyright infringement
								("Copyright Agent") can be reached as follows: Sup Labs Ltd., email: contact@sup.co.
							</Paragraph>
						</Section>

						<Section title="ASSIGNMENT">
							<Paragraph>
								This Agreement is only for the benefit of you, the Creator. You shall have no right
								to assign this Agreement or any benefits or obligations hereunder to any other party
								or legal entity. Any attempted assignment shall be void. Provided, however, if you
								are a Company or a legal entity using our Platform and Services, then upon our prior
								written approval, your employees or consultants may participate in the Campaigns.
								Sup Labs Ltd may assign this Agreement at its sole discretion and without any
								limitations.
							</Paragraph>
						</Section>

						<Section title="ANTI-BRIBERY AND EXPORT COMPLIANCE">
							<Paragraph>
								You agree not to promote, approach, use, distribute, transfer, provide, sublicense,
								share with, or otherwise offer the Services in violation of any Laws or this
								Agreement, including, without limitation, the UK Bribery Act 2010 and similar
								anti-corruption statutes in all jurisdictions. Without limiting the foregoing, you
								will not knowingly directly or indirectly export, re-export, transfer, make
								available, or release (collectively, "Export") the Services to any destination,
								person, entity, or end use prohibited or restricted under UK law without prior UK
								government authorization to the extent required by regulation, including without
								limitation, any parties listed on any denied parties lists or specially designated
								nationals lists maintained under the UK Export Control Act or the Security, and the
								Foreign Asset Control Regulations (31 CFR 500 et seq.) administered by the UK
								Department for International Trade, Office of Export Control without appropriate UK
								government authorization to the extent required by
							</Paragraph>
						</Section>

						<Section title="MODIFICATIONS">
							<Paragraph>
								Sup Labs Ltd reserves the right, at its sole discretion, to modify or discontinue,
								temporarily or permanently, the Platform, Services, or to modify this Agreement at
								any time and without prior notice. If we modify this Agreement, we will post the
								modification on the Website or the App. Modifications to this Agreement will
								automatically take effect upon posting; provided, however, that material changes to
								this Agreement will be effective as to an existing Creator thirty (30) days after
								posting. By continuing to access or use our Platform or Services after we have
								posted a modification, you are indicating that you agree to be bound by the modified
								Agreement. If the modified Agreement is not acceptable to you, your only recourse is
								to cease accessing or using the Platform and Services.
							</Paragraph>
						</Section>

						<Section title="NON-DISPARAGEMENT">
							<Paragraph>
								During the Term and for five (5) years after that, you agree that you will not
								disparage Sup Labs Ltd or any of Sup Labs Ltd’s officers, directors, or employees or
								otherwise take any action that reasonably can be expected to adversely affect Sup
								Labs Ltd’s reputation. For purposes of this Agreement, "disparage" shall mean any
								negative statement, whether written or oral, about Sup Labs Ltd or any of its
								officers, directors, or employees. You agree and acknowledge that this
								non-disparagement provision is a material term of this Agreement, the absence of
								which would have resulted in Sup Labs Ltd refusing to enter into this Agreement.
							</Paragraph>
						</Section>

						<Section title="FORCE MAJEURE">
							<Paragraph>
								Neither you nor us shall be obliged to perform any of its obligations herein if
								either you or us is prevented from doing so by a situation of force majeure. "Force
								majeure" events shall include events beyond the reasonable control of either you or
								us, including acts of God, acts of government, acts of nature, strikes or riots, as
								well as improper performance by Sup Labs Ltd’s suppliers and customers, including
								Sup Labs Ltd’s clients, agencies, or technology suppliers, including defects in
								objects, materials, or software of third parties.
							</Paragraph>
						</Section>

						<Section title="GOVERNING LAW">
							<Paragraph>
								This Agreement shall be governed by the law of England and Wales, without respect to
								its conflicts of laws principles. We each agree to submit to the exclusive
								jurisdiction of the courts of England and Wales for any actions not subject to the
								Dispute Resolution and Arbitration provisions as set forth in Section 28 below.
							</Paragraph>
						</Section>

						<Section title="DISPUTE RESOLUTION AND ARBITRATION">
							<Paragraph>
								PLEASE READ THE FOLLOWING SECTION CAREFULLY BECAUSE IT REQUIRES YOU TO ARBITRATE
								CERTAIN DISPUTES AND CLAIMS WITH SUP LABS LTD AND LIMITS THE MANNER IN WHICH YOU CAN
								SEEK RELIEF FROM US.
							</Paragraph>

							<Paragraph>
								28.1. Binding Arbitration. Except for any disputes, claims, suits, actions, causes
								of action, demands, or proceedings (collectively, "Disputes") in which either party
								seeks to bring an individual action in small claims court or seeks injunctive or
								other equitable relief for the alleged unlawful use of intellectual property,
								including, without limitation, copyrights, trademarks, trade names, logos, trade
								secrets, or patents, you and Sup Labs Ltd agree (a) to waive your and The Sup Group
								Ltd’s respective rights to have any and all Disputes arising from or related to this
								Agreement, use of our Services and Platform, resolved in a court, and (b) to waive
								your and Sup Labs Ltd’s respective rights to a jury trial. Instead, you and Sup Labs
								Ltd agree to arbitrate Disputes through binding arbitration (which is the referral
								of a Dispute to one or more persons charged with reviewing the Dispute and making a
								final and binding determination to resolve it instead of having the Dispute decided
								by a judge or jury in court).
							</Paragraph>

							<Paragraph>
								28.2. No Class Arbitrations, Class Actions, or Representative Actions. You and The
								Sup Group Ltd agree that any Dispute arising out of or related to this Agreement or
								the Services, Platform, Website, or App is personal to you and Sup Labs Ltd and that
								such Dispute will be resolved solely through individual arbitration and will not be
								brought as a class arbitration, class action, or any other type of representative
								proceeding. You and Sup Labs Ltd agree that there will be no class arbitration or
								arbitration in which an individual attempts to resolve a Dispute as a representative
								of another individual or group of individuals. Further, you and Sup Labs Ltd agree
								that a Dispute cannot be brought as a class or other type of representative action,
								whether within or outside of arbitration, or on behalf of any other individual or
								group of individuals.
							</Paragraph>

							<Paragraph>
								28.3. Arbitration Act 1996. You and Sup Labs Ltd agree that this Agreement affects
								interstate commerce and that the enforceability of this Section 28 shall be both
								substantively and procedurally governed by and construed and enforced in accordance
								with the Arbitration Act 1996, to the maximum extent permitted by applicable law.
							</Paragraph>

							<Paragraph>
								28.4. Notice; Informal Dispute Resolution. You and Sup Labs Ltd agree that each
								party will notify the other party in writing of any arbitrable or small claims
								Dispute within thirty (30) days of the date it arises, so that the parties can
								attempt in good faith to resolve the Dispute informally. Notice to Sup Labs Ltd
								shall be sent by certified mail or courier to Sup Labs Ltd, 483 Green Lanes, London,
								N13 4BS, or via email: contact@sup.co. Your notice must include (a) your name,
								postal address, telephone number, the email address you use or used for your Sup
								Labs Ltd account, and if different, an email address at which you can be contacted,
								(b) a description in reasonable detail of the nature or basis of the Dispute, and
								(c) the specific relief that you are seeking. Our notice to you will be sent
								electronically in accordance with this Agreement and will include (x) our name,
								postal address, telephone number, and an email address at which we can be contacted
								with respect to the Dispute, (y) a description in reasonable detail of the nature or
								basis of the Dispute, and (z) the specific relief that we are seeking. If you and
								Sup Labs Ltd cannot agree on how to resolve the Dispute within thirty (30) days
								after the date notice is received by the applicable party, then either you or The
								Sup Group Ltd may, as appropriate and in accordance with this Section, commence an
								arbitration proceeding.
							</Paragraph>

							<Paragraph>
								28.5. Process. EXCEPT FOR DISPUTES IN WHICH EITHER PARTY SEEKS TO BRING AN
								INDIVIDUAL ACTION IN SMALL CLAIMS COURT OR SEEKS INJUNCTIVE OR OTHER EQUITABLE
								RELIEF FOR THE ALLEGED UNLAWFUL USE OF INTELLECTUAL PROPERTY, INCLUDING, WITHOUT
								LIMITATION, COPYRIGHTS, TRADEMARKS, TRADE NAMES, LOGOS, TRADE SECRETS OR PATENTS,
								YOU AND SUP LABS LTD AGREE THAT ANY DISPUTE MUST BE COMMENCED OR FILED BY YOU OR SUP
								LABS LTD WITHIN ONE (1) YEAR OF THE DATE THE DISPUTE AROSE, OTHERWISE THE UNDERLYING
								CLAIM IS PERMANENTLY BARRED (WHICH MEANS THAT YOU AND THE SUP GROUP LTD WILL NO
								LONGER HAVE THE RIGHT TO ASSERT SUCH CLAIM REGARDING THE DISPUTE).
							</Paragraph>

							<Paragraph>
								28.6. Arbitration Rules. You and Sup Labs Ltd agree that (a) any arbitration will
								occur in London, England, (b) arbitration will be conducted confidentially by a
								single arbitrator in accordance with the rules and procedures of the Chartered
								Institute of Arbitrators (CIArb) then in effect, except as modified by this "Dispute
								Resolution" section, and (c) that the courts of England and Wales have exclusive
								jurisdiction over any appeals and the enforcement of an arbitration award. You may
								also litigate a Dispute in the small claims court located in the county of your
								billing address if the Dispute meets the requirements to be heard in small claims
								court.
							</Paragraph>

							<Paragraph>
								28.7. Authority of Arbitrator. As limited by the applicable laws, these Terms, and
								the rules and procedures of the CIArb, the arbitrator will have (a) the exclusive
								authority and jurisdiction to make all procedural and substantive decisions
								regarding a Dispute, including the determination of whether a Dispute is arbitrable,
								and (b) the authority to grant any remedy that would otherwise be available in
								court; provided, however, that the arbitrator does not have the authority to conduct
								a class arbitration or a representative action, which is prohibited by this
								Agreement. The arbitrator may only conduct an individual arbitration and may not
								consolidate more than one individual's claims, preside over any type of class or
								representative proceeding, or preside over any proceeding involving more than one
								individual. Notwithstanding anything to the contrary herein or the applicable rules
								and procedures of the CIArb, discovery in the arbitration shall be limited to one
								set of interrogatories, one set of requests for admissions, and one set of requests
								for production of documents. The arbitrator's award of damages must be consistent
								with the terms of the "Limitation of Liability" section above as to the types and
								amounts of damages for which a party may be held liable. The arbitrator may award
								declaratory or injunctive relief only in favor of the claimant and only to the
								extent necessary to provide relief warranted by the claimant's individual claim. If
								you prevail in arbitration, you will be entitled to an award of attorneys' fees and
								expenses, to the extent provided under applicable law. We will not seek, and hereby
								waive all rights we may have under applicable law to recover, attorneys' fees and
								expenses if we prevail in arbitration.
							</Paragraph>

							<Paragraph>
								28.8. Rules and Procedures of CIArb. The rules and procedures of the CIArb are
								available at www.ciarb.org or by calling the CIArb at +44 (0)20 7421 7444. By
								agreeing to be bound by this Agreement, you either (a) acknowledge and agree that
								you have read and understand the rules and procedures of the CIArb, or (b) waive
								your opportunity to read the rules and procedures of the CIArb and any claim that
								the rules and procedures of the CIArb are unfair or should not apply for any reason.
							</Paragraph>

							<Paragraph>
								28.9. Severability. If any term, clause, or provision of this Section is held
								invalid or unenforceable, it will be so held to the minimum extent required by law,
								and all other terms, clauses, and provisions of this Section will remain valid and
								enforceable. Further, the waivers set forth in this Section are severable from the
								other provisions of this Agreement and will remain valid and enforceable, except as
								prohibited by applicable law.
							</Paragraph>

							<Paragraph>
								28.10. Opt-Out Right. You have the right to opt-out of binding arbitration within
								thirty (30) days of the date you first accepted the terms of this Section by writing
								to: Sup Labs Ltd, 483 Green Lanes, London, N13 4BS, or via email: contact@sup.co. In
								order to be effective, the opt-out notice must include your full name and clearly
								indicate your intent to opt-out of binding arbitration. By opting-out of binding
								arbitration, you are agreeing to resolve Disputes in accordance with Section 28.
							</Paragraph>
						</Section>

						<Section title="ENTIRE AGREEMENT">
							<Paragraph>
								This Agreement, along with the Privacy Policy, constitutes the entire agreement
								between you and us and supersedes any prior agreements between you and us with
								respect to the subject matter herein. Our failure to exercise or enforce any right
								or provision of this Agreement will not constitute a waiver of such right or
								provision. If any provision of this Agreement is found by a court of competent
								jurisdiction to be invalid, we both nevertheless agree that the court should
								endeavor to give effect to our intentions as reflected in the provision, and the
								other provisions of this Agreement remain in full force and effect. You agree that
								regardless of any statute or law to the contrary, any claim or cause of action
								arising out of or related to use of the Services or this Agreement must be filed
								within one (1) year after such claim or cause of action arose or be forever barred.
								A party's failure to act with respect to a breach by the other party does not
								constitute a waiver of the party's right to act with respect to subsequent or
								similar breaches. All the sections intended to survive the termination of this
								Agreement shall survive. The section titles in this Agreement are for convenience
								only and have no legal or contractual effect.
							</Paragraph>

							<Paragraph>
								Except as explicitly stated otherwise, any notices to Sup Labs Ltd shall be given by
								certified mail, postage prepaid and return receipt requested to The Sup Group Ltd,
								483 Green Lanes, London, N13 4BS, or via email: contact@sup.co. Any notices to you
								shall be provided to you through our Website or App, or given to you via the email
								address or physical address you provide to Sup Labs Ltd during the registration
								process.
							</Paragraph>
						</Section>

						<Section title="PRIVACY">
							<Paragraph>
								Each Party agrees to fully comply with the applicable privacy regulations. We will
								use any personal information that we may collect or obtain in connection with the
								Services in accordance with our Privacy Policy available at:
								https://sup.co/privacy/, as may be updated from time to time. You further agree that
								we may use personal information that you provide or make available to us in
								accordance with the Privacy Policy.
							</Paragraph>
						</Section>

						<Section title="DISTRIBUTOR REQUIREMENTS AND USAGE RULES">
							<Paragraph>
								Apple. If you download the App from the Apple, Inc. ("Apple") App Store (or in any
								event if you download an Apple iOS App), then, without derogating from the warranty
								disclaimers and limitation of liability as set forth in the Agreement:
							</Paragraph>
							<Paragraph>
								<ul className="list-inside list-[lower-roman]">
									<li>
										You acknowledge and agree that:
										<ol className="list-inside list-[lower-alpha] pl-4">
											<li>
												this Agreement is concluded between Sup Labs Ltd and you only, and not with
												Apple, and Sup Labs Ltd and its licensors, and not Apple, are solely
												responsible for the App and the content thereof.
											</li>
											<li>
												your use of the Platform through the App is also subject to the usage rules
												established by Apple, including those set forth in the Apple App Store Terms
												of Service, effective as of the date that you enter into this Agreement.
											</li>
											<li>
												the license granted herein is limited to a non-transferable right to use the
												App on an Apple iPhone, iPod Touch, iPad, or other Apple-branded product
												that you own or control and that runs the iOS;
											</li>
											<li>
												Sup Labs Ltd is solely responsible for providing any maintenance and support
												services with respect to the App. Apple has no obligation whatsoever to
												furnish any maintenance and support services with respect to the App;
											</li>
											<li>
												Sup Labs Ltd is solely responsible for any product warranties, whether
												express or implied by law, to the extent not effectively disclaimed. In the
												event of any failure of the App to conform to any applicable warranty, you
												may notify Apple, and Apple will, to the extent applicable, refund any
												purchase price paid (if any) by you for the App to you. To the maximum
												extent permitted by applicable law, Apple will have no other warranty
												obligation whatsoever with respect to the App, and any other claims, losses,
												liabilities, damages, costs, or expenses attributable to any failure to
												conform to any warranty will be Sup Labs Ltd's sole responsibility;
											</li>
											<li>
												Sup Labs Ltd, and not Apple, is responsible for addressing any product
												claims you, or any third party, may have relating to the App or your
												possession and/or use of the App, including, but not limited to: (a) product
												liability claims; (b) any claim that the App fails to conform to any
												applicable legal or regulatory requirement; and (c) claims arising under
												consumer protection or similar legislation;
											</li>
											<li>
												in the event of any third party claim that the App or your possession and
												use of the App infringes that third party's intellectual property rights,
												Apple shall not be responsible for the investigation, defense, settlement,
												and discharge of any such intellectual property infringement claim;
											</li>
											<li>
												Apple, and its subsidiaries, are third party beneficiaries of this
												Agreement, and that, upon your acceptance of the terms and conditions of
												this Agreement, Apple will have the right (and will be deemed to have
												accepted the right) to enforce this Agreement against you as a third-party
												beneficiary thereof.
											</li>
										</ol>
									</li>
									<li>
										You represent and warrant that:
										<ul className="list-inside list-[lower-alpha] pl-4">
											<li>
												you are not located in a country that is subject to a UK Government embargo
												or that has been designated by the UK Government as a "terrorist supporting"
												country; and
											</li>
											<li>
												you are not listed on any UK Government list of prohibited or restricted
												parties.
											</li>
										</ul>
									</li>

									<li>
										If you have any questions, complaints, or claims regarding the App, please
										contact Sup Labs Ltd at: Email: info@sup.co Address: 483 Green Lanes, London,
										N13 4BS
									</li>

									<li>
										By entering into this Agreement you, to the extent legally permitted, hereby
										waive any applicable law requiring that this Agreement be localized to meet your
										language and other local requirements. To the extent that the foregoing is not
										permitted, you agree to be bound by the standard Apple Licensed Application End
										User License Agreement which is part of the Apple App Store Terms of Service, at
										apple.com/legal/itunes/gb/terms.html#SERVICE (as amended from time to time).
									</li>
								</ul>
							</Paragraph>

							<Paragraph>
								PLEASE NOTE THAT BY USING THE WEBSITE, APP, PLATFORM, AND/OR SERVICES, YOU ARE
								AGREEING TO BE BOUND BY AND TO COMPLY WITH THE TERMS DESCRIBED HEREIN. IF YOU DO NOT
								AGREE TO THESE TERMS, PLEASE DO NOT USE OUR WEBSITE, APP, PLATFORM, AND/OR SERVICES
								AND EXIT IMMEDIATELY.
							</Paragraph>

							<Paragraph>Last updated: July 16, 2023</Paragraph>
						</Section>
					</ol>
				</div>
			</div>
		</div>
	)
}

type SectionProps = {
	title: string
}
const Section = ({ title, children }: React.PropsWithChildren<SectionProps>) => {
	return (
		<li className="mt-8 text-2xl">
			<h2 className="inline pb-2 text-2xl font-bold">{title}</h2>
			<div className="text-base">{children}</div>
		</li>
	)
}

type ParagraphProps = {
	weight?: 'bold'
}

const Paragraph = ({ children, weight }: React.PropsWithChildren<ParagraphProps>) => {
	return (
		<p
			className={cn('mb-4', {
				'font-bold': weight === 'bold',
			})}
		>
			{children}
		</p>
	)
}
